module.exports = __webpack_public_path__ + "static/media/photo233.d1c62c73.jpg";